// 施工例概算数
export const SEKOU_COUNT = 34000;
